<template>
	<div>
		<div class="form-group form-active  pt20">
            <label for="nome">{{pergunta}}</label>

			<div class="form-check">
				<input class="form-check-input" type="radio" id="resposta1" v-model="resposta" :value="true" :class="{ 'is-invalid': respostaInvalida }">
				<label class="form-check-label" for="resposta1">Sim</label>
			</div>

			<div class="form-check">
				<input class="form-check-input" type="radio" id="resposta2" v-model="resposta" :value="false" :class="{ 'is-invalid': respostaInvalida }">
				<label class="form-check-label" for="resposta2">Não</label>
			</div>

            <div class="invalid-feedback" :class="{ 'd-block': respostaInvalida}">
                <p>Por favor, responda a pergunta!</p>
            </div>

            <div class="text-right">
            	<button v-if="perguntaAtual > 0" class="btn btn-light" @click="voltar">Voltar</button>
            	<button v-if="perguntaAtual < questoes.length-1" class="btn btn-primary" @click="proximo">Próximo</button>
            	<button v-if="perguntaAtual == questoes.length-1" class="btn btn-primary" @click="enviar">Enviar</button>
            </div>

        </div>
	</div>
</template>

<script>
	export default {
		name: 'Questionario',
		props: ['questoes'],
		data () {
			return {
				/*respostas: new Array(
					{"pergunta":"Você sabe qual o lucro que sua empresa gera ao final de cada mês?","resposta":false},{"pergunta":"Você sabe quais são os produtos/serviços mais rentáveis da sua empresa?","resposta":false},{"pergunta":"Sua empresa possui dívidas?","resposta":false},{"pergunta":"Sua empresa possui capital de giro próprio? (Reservas de recurso próprios para pagar as contas)","resposta":false},{"pergunta":"Existem atrasos em pagamentos como, por exemplo, folha de pagamento, impostos, fornecedores, prestadores de serviço, etc?","resposta":false},{"pergunta":"Você consegue monitorar todos os setores da sua empresa?","resposta":false},{"pergunta":"A sua empresa tem rotatividade de funcionários?","resposta":false},{"pergunta":"Seus funcionários são comprometidos com o seu negócio?","resposta":false},{"pergunta":"Você sente que seu negócio só funciona quando você está presente?","resposta":false},{"pergunta":"Você utiliza parâmetros para avaliar o desempenho dos colaboradores da sua empresa?","resposta":false},{"pergunta":"Você sabe como aumentar as vendas da sua empresa?","resposta":false},{"pergunta":"Você sente que às vezes fica na mão de funcionários antigos e teimosos?","resposta":false},{"pergunta":"Existe padrão nos produtos/serviços da sua empresa?","resposta":true},{"pergunta":"O atendimento na sua empresa é padronizado?","resposta":true},{"pergunta":"Você conhece o ponto de equilíbrio do seu negócio?","resposta":true},{"pergunta":"Existe controle financeiro (fluxo de caixa, monitoramento de gastos, etc) na sua empresa?","resposta":true},{"pergunta":"Você sabe se sua empresa está gerando lucro ou dando prejuízo?","resposta":true},{"pergunta":"A administração do seu negócio é realizada por familiares?","resposta":false},{"pergunta":"A administração do seu negócio é realizada por familiares?","resposta":"não respondido"},{"pergunta":"Existe controle de estoque na sua empresa?","resposta":true},{"pergunta":"Você acredita que seus funcionários podem fazer as tarefas melhor que você?","resposta":false},{"pergunta":"A missão, visão e valores da sua empresa estão definidos?","resposta":true},{"pergunta":"São realizados planejamentos de curto, médio e longo prazo na sua empresa?","resposta":true},{"pergunta":"Você utiliza indicadores e/ou ferramentas nas tomadas de decisão?","resposta":true},{"pergunta":"Você utiliza algum software para ajudar na gestão da sua empresa?","resposta":false},{"pergunta":"Você tem uma carteira de clientes atuais e potenciais organizada?","resposta":true},{"pergunta":"A satisfação dos seus clientes é avaliada?","resposta":false},{"pergunta":"Os processos principais do seu negócio são executados de forma padronizada com padrões documentados?","resposta":false},{"pergunta":"As funções e responsabilidades dos seus funcionários estão definidas?","resposta":false},{"pergunta":"Você tem um roteiro de contratação claro e dinâmico desenvolvido para novos contratados?","resposta":false},{"pergunta":"Os colaboradores contratados são treinados antes de exercer suas funções?","resposta":false},{"pergunta":"Você tem um plano de Marketing atualizado para o seu negócio?","resposta":true},{"pergunta":"Existe um plano de vendas claro e atualizado para a sua empresa?","resposta":true},{"pergunta":"Você tem tempo para investir em outros negócios?","resposta":true},{"pergunta":"Você investe tempo em seu desenvolvimento gerencial (cursos e treinamentos)?","resposta":true},{"pergunta":"Sua empresa consegue realizar seus sonhos pessoais?","resposta":true},{"pergunta":"Atualmente, você consegue tirar férias?","resposta":false},{"pergunta":"Sua empresa está afetando negativamente sua vida pessoal e prejudicando seu relacionamento e tempo com a família?","resposta":false},
				),
				perguntaAtual: 39,*/
				respostas: new Array(),
				perguntaAtual: 0,
				pergunta: null,
				resposta: null,
				respostaInvalida: false,
				resultado: 0,
			}
		},
		computed: {
			questoesLength () {
				return this.questoes.length;
			}
		},
		methods: {
			voltar () {
				this.respostaInvalida = false;

				this.perguntaAtual--;

				if(this.questoes[this.perguntaAtual].requer_anterior && !this.respostas[this.perguntaAtual-1]) {
					this.perguntaAtual--;
				}

				this.pergunta = this.questoes[this.perguntaAtual].pergunta;

				this.resposta = this.respostas[this.perguntaAtual].resposta != null ? this.respostas[this.perguntaAtual].resposta : null;

			},
			proximo () {
				//para validação, se tenho resposta processo
				if (this.resposta != null) {

					if (this.respostas[this.perguntaAtual] != null) {
						this.respostas[this.perguntaAtual] = {
							pergunta: this.pergunta,
							resposta: this.resposta
						};
					}
					else {
						this.respostas.push({
							pergunta: this.pergunta,
							resposta: this.resposta
						});
					}

					//envia as perguntas quando chegar na última resposta
					if(this.perguntaAtual == this.questoes.length-1){
						this.respostas.forEach(value => {
							//Preciso contar as respostas "sim", pois a porcentagem de "sim" define o quão boa é agestão da empresa.
							if (value.resposta === true) {
								this.resultado++;
							}

						});

						this.$parent.showResultado(this.resultado, this.respostas);
					}

					this.perguntaAtual++;

					if(this.questoes[this.perguntaAtual].requer_anterior && !this.resposta) {
						if(this.respostas[this.perguntaAtual] != null) {
							this.respostas[this.perguntaAtual] = {
								pergunta: this.pergunta,
								resposta: 'não respondido'
							};
						}
						else {
							this.respostas.push({
								pergunta: this.pergunta,
								resposta: 'não respondido'
							});
						}

						this.perguntaAtual++;

					}

					this.pergunta = this.questoes[this.perguntaAtual].pergunta;

					if (this.questoes)
						this.resposta = this.respostas[this.perguntaAtual] != null ? this.respostas[this.perguntaAtual].resposta == 'não respondido' ? null : this.respostas[this.perguntaAtual].resposta : null;

					this.respostaInvalida = false;

					
				}
				else {
					this.respostaInvalida = true;
				}
			},
			enviar () {

				this.proximo();
				/*this.respostas.forEach(value => {
					//Preciso contar as respostas "sim", pois a porcentagem de "sim" define o quão boa é agestão da empresa.
					if (value.resposta === true) {
						this.resultado++;
					}

				});

				this.$parent.showResultado(this.resultado, this.respostas);*/

			},
		},
		beforeMount () {
			this.pergunta = this.questoes[0].pergunta;
		}
	}
</script>

<style scoped>

</style>
